import React from "react";
import {classNames, Logo, SelectValueComponentProps, TextSkeleton} from "peggirkit";
import {RestaurantLocation} from "@/data/entities/restaurant";
import icon from "@/assets/img/favicon/favicon.svg";
import {ChevronDownIcon} from "@heroicons/react/16/solid";
import {FormattedMessage} from "react-intl";

const SelectedLocationOption = ({option, disabled,}: SelectValueComponentProps<RestaurantLocation>) => (
    <div
        className={classNames(
            "transition-colors p-2 relative w-full rounded-md text-left text-black dark:text-white",
            disabled
                ? "bg-black/5 dark:bg-white/5 cursor-not-allowed"
                : "hover:bg-black/5 dark:hover:bg-white/5",
        )}
    >
        <div
            className={classNames(
                "w-full flex items-center gap-3",
                disabled ? "opacity-50" : "",
            )}
        >
            <Logo
                src={icon}
                alt={"Eataliano"}
                width={66}
                height={66}
                imgSizingClassname={"h-9 w-9"}
            />

            <div className={"flex flex-col gap-0.5 w-full"}>
                <strong className={"font-bold text-sm"}>
                    {
                        option
                            ? option.displayValue
                            : <TextSkeleton className={"w-1/2 h-5"}/>
                    }
                </strong>
                <div
                    className={classNames(
                        "transition-opacity text-xs w-full flex flex-row items-end gap-1 justify-start opacity-60",
                        disabled ? "" : "group-hover:opacity-100"
                    )}
                >
                    <span><FormattedMessage id={"pick-a-location"}/></span>
                    <ChevronDownIcon className={"w-4"}/>
                </div>
            </div>
        </div>
    </div>
);

export default SelectedLocationOption;